import React from "react";

interface MerchantLoaderProps {
  label?: string;
  size?: "page" | "panel" | "inline";
}

const MerchantLoader: React.FC<MerchantLoaderProps> = ({
  label = "Loading…",
  size = "panel",
}) => {
  return (
    <div
      className={`zulu-loader zulu-loader--${size}`}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <span className="zulu-loader__circle" aria-hidden="true" />
      <span className="zulu-loader__text">{label}</span>
    </div>
  );
};

export default MerchantLoader;
